module.exports = __webpack_public_path__ + "static/img/tef_error.60fdb8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/tef_error.png
// module id = by0f
// module chunks = 1